import { forEach } from 'ramda';
import { CombinedState, combineReducers, Reducer } from 'redux';
import { IStateModule } from './types';

export class RootReducer {
	rootReducer: Reducer<CombinedState<any>>;

	constructor(
		private activeModules: IStateModule[],
		reducer?: Reducer<CombinedState<any>>,
	) {
		if (reducer) {
			this.rootReducer = reducer;
		} else {
			this.rootReducer = this.createRootReducer();
		}
	}

	getActiveModules(): IStateModule[] {
		return this.activeModules;
	}

	setActiveModules(activeModule: IStateModule[]): IStateModule[] {
		return (this.activeModules = activeModule);
	}

	createRootReducer(): any {
		const reducers: any = {};
		if (this.getActiveModules().length) {
			forEach(module => {
				reducers[module.getRootKeyInStore()] = module.getReducers();
			}, this.getActiveModules());
		}
		return combineReducers(reducers);
	}

	getRootReducer(): Reducer {
		return this.rootReducer;
	}
}
